import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { MethodType } from '@michelin/central-provider/dist/helpers/createAPICall';
import { ContactListingOVM, ResponseOVM } from '@michelin/fcp-view-models';
import { useQuery } from '@tanstack/react-query';
import GLOBAL_CONFIG from '../global-variables';

const baseURL = GLOBAL_CONFIG.externalAPIUrl;

export async function deleteContacts({ fleetId, ids }: { fleetId: string; ids: string[] }) {
  const apiType: MaestroAPI = { method: MethodType.DELETE, endpoint: `cp-be/contacts/${fleetId}`, baseURL };

  const response = await maestroApiCall(apiType, { contact_ids: ids.join(',') }).then((res) => res.data);
  return response;
}

async function getContactsForRole(
  apiType: MaestroAPI,
  role: string,
  customerType?: string,
): Promise<ContactListingOVM[]> {
  const res = await maestroApiCall<ResponseOVM<ContactListingOVM[]>>(apiType, {
    role,
    contact_level: customerType?.toUpperCase() ?? '',
  });
  return res?.data ?? [];
}

async function getContacts(fleetId: string, roleAreas: string[], customerType?: string): Promise<ContactListingOVM[]> {
  const apiType: MaestroAPI = { method: MethodType.GET, endpoint: `cp-be/contacts/${fleetId}`, baseURL };

  const contactsByRole = await Promise.all(roleAreas.map((role) => getContactsForRole(apiType, role, customerType)));

  const contactsById = new Map<string, ContactListingOVM>();
  contactsByRole.flat().forEach((contact) => {
    if (contact.id) contactsById.set(contact.id, contact);
  });

  return Array.from(contactsById.values());
}

export function useContactsList(fleetId?: string, roleAreas: string[] = [], customerType?: string) {
  return useQuery(
    ['contacts-list', fleetId, roleAreas, customerType],
    () => getContacts(fleetId as string, roleAreas, customerType),
    {
      enabled: !!fleetId && roleAreas.length > 0,
    },
  );
}
